var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardLocationYellowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5305 5.0625C21.9716 5.0625 12.593 13.5042 12.593 23.9062C12.593 40.6562 33.5305 63.6875 33.5305 63.6875C33.5305 63.6875 54.468 40.6562 54.468 23.9062C54.468 13.5042 45.0893 5.0625 33.5305 5.0625ZM33.5305 34.375C31.874 34.375 30.2548 33.8838 28.8776 32.9636C27.5003 32.0433 26.4268 30.7353 25.793 29.205C25.1591 27.6746 24.9932 25.9907 25.3164 24.3661C25.6395 22.7415 26.4372 21.2492 27.6084 20.078C28.7797 18.9067 30.272 18.1091 31.8966 17.7859C33.5212 17.4628 35.2051 17.6286 36.7354 18.2625C38.2658 18.8964 39.5738 19.9698 40.494 21.3471C41.4143 22.7244 41.9055 24.3436 41.9055 26C41.903 28.2204 41.0199 30.3493 39.4498 31.9193C37.8797 33.4894 35.7509 34.3726 33.5305 34.375Z",
    fill: "#F4B652"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLocationYellowIcon);
export default __webpack_public_path__ + "static/media/dashboard_location_yellow_icon.bab5116788231f89c3e48b53abad90bd.svg";
export { ForwardRef as ReactComponent };